export class ValleyPopupStatusModel {
  showGameDemo:boolean = false;
}
